// Event Types with their pricing tiers and details
export const EVENT_PRICING = {
  portrait: {
    name: "Portrait",
    icon: "User",
    starter: null,
    classic: 65,
    elite: 100,
    recommended: "classic",
    showRecommendedInPackageStep: true,
    coverage: "Outdoor locations in London",
    packages: {
      classic: {
        price: 65,
        description: "45-minute session with 20-30 professionally edited photos. Outdoor shoot at your desired location. High-quality images delivered online via Google Drive. Perfect for personal portraits, social media, couples, or special moments.",
        features: [
          "45-minute portrait session",
          "20-30 professionally edited photos",
          "Outdoor shoot at your desired location",
          "High-quality images delivered via Google Drive"
        ],
        note: "Location: Outdoor locations in London. Outside London: Additional £55 travel fee."
      },
      elite: {
        price: 100,
        description: "Extended portrait session with 20-50 professionally edited photos. Outdoor shoot at your desired location. High-quality images delivered online via Google Drive.",
        features: [
          "Extended portrait session",
          "20-50 professionally edited photos",
          "Outdoor shoot at your desired location",
          "High-quality images delivered via Google Drive"
        ],
        note: "Excludes transport charges."
      }
    }
  },
  maternity: {
    name: "Maternity Shoot",
    icon: "Baby",
    starter: null, // Not available
    classic: 200,
    elite: 400,
    recommended: "classic",
    showRecommendedInPackageStep: true,
    coverage: "Studio or outdoor location",
    packages: {
      classic: {
        price: 200,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 400,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  baptism: {
    name: "Baptism",
    icon: "Church",
    starter: 250,
    classic: 300,
    elite: 360,
    coverage: "Home, park, venue, church",
    packages: {
      starter: {
        price: 250,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 300,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 360,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  communion: {
    name: "Communion",
    icon: "Cross",
    starter: 300,
    classic: 350,
    elite: 410,
    coverage: "Home, park, venue",
    packages: {
      starter: {
        price: 300,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 350,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 410,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  confirmation: {
    name: "Confirmation",
    icon: "BookOpen",
    starter: 300,
    classic: 350,
    elite: 410,
    coverage: "Home, park, venue",
    packages: {
      starter: {
        price: 300,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 350,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 410,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  first_birthday: {
    name: "1st Birthday",
    icon: "Cake",
    starter: 250,
    classic: 300,
    elite: 360,
    coverage: "Home, park, venue",
    packages: {
      starter: {
        price: 250,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 300,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 360,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  "21st_birthday": {
    name: "21st Birthday",
    icon: "PartyPopper",
    starter: 300,
    classic: 350,
    elite: 410,
    coverage: "Home, park, venue",
    packages: {
      starter: {
        price: 300,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 350,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 410,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  "50th_birthday": {
    name: "50th Birthday",
    icon: "Award",
    starter: 300,
    classic: 350,
    elite: 410,
    coverage: "Home, park, venue",
    packages: {
      starter: {
        price: 300,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 350,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 410,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  civil_wedding: {
    name: "Civil Wedding",
    icon: "Heart",
    starter: 350,
    classic: 400,
    elite: 460,
    coverage: "Home, park, venue, office",
    packages: {
      starter: {
        price: 350,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 400,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 460,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  silver_golden_wedding: {
    name: "25th Silver / 50th Golden Wedding",
    icon: "Sparkles",
    starter: 300,
    classic: 350,
    elite: 410,
    coverage: "Home, park, venue",
    packages: {
      starter: {
        price: 300,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 350,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 410,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  },
  house_warming: {
    name: "House Warming",
    icon: "Home",
    starter: null,
    classic: 150,
    elite: null,
    coverage: "Home",
    packages: {
      classic: {
        price: 150,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Professional photography", "High resolution images"]
      }
    }
  },
  other: {
    name: "Other",
    icon: "Camera",
    saver_london: 130,
    saver_outside_london: 210,
    starter: 250,
    classic: 300,
    elite: 360,
    coverage: "As per requirement",
    packages: {
      saver_london: {
        price: 130,
        description: "4 hours coverage. 1-2 day delivery. 50 limited professionally edited photos. High resolution images. Extra pics £3/per photo.",
        features: ["4 hours coverage", "1-2 day delivery", "50 professionally edited photos", "High resolution images", "Extra pics £3/per photo"],
        note: "Only eligible events only."
      },
      saver_outside_london: {
        price: 210,
        description: "4 hours coverage. 1-2 day delivery. 80 limited professionally edited photos. High resolution images. Extra pics £3/per photo.",
        features: ["4 hours coverage", "1-2 day delivery", "80 professionally edited photos", "High resolution images", "Extra pics £3/per photo"],
        note: "Only eligible events only."
      },
      starter: {
        price: 250,
        description: "High quality colour graded/edited pictures shared online via Google Drive or pendrive within 6-15 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images"]
      },
      classic: {
        price: 300,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing"]
      },
      elite: {
        price: 360,
        description: "High quality colour graded/edited precise masking pictures shared online via Google Drive or pendrive within 6-69 days after the shoot, or sooner if available.",
        features: ["Unlimited professionally edited photos", "High resolution images", "Priority editing", "Additional 20-page Photo Book"]
      }
    }
  }
};

// Package details (generic)
export const PACKAGE_DETAILS = {
  saver_london: {
    name: "Saver (London)",
    description: "Budget-friendly London coverage",
    deliveryTime: "1-2 days",
    features: [
      "4 hours coverage",
      "50 professionally edited photos",
      "High resolution images",
      "1-2 day delivery",
      "Extra pics £3/per photo"
    ],
    note: "Only eligible events only."
  },
  saver_outside_london: {
    name: "Saver (Outside London)",
    description: "Budget-friendly coverage outside London",
    deliveryTime: "1-2 days",
    features: [
      "4 hours coverage",
      "80 professionally edited photos",
      "High resolution images",
      "1-2 day delivery",
      "Extra pics £3/per photo"
    ],
    note: "Only eligible events only."
  },
  starter: {
    name: "Starter",
    description: "Perfect for intimate events",
    deliveryTime: "6-15 days",
    features: [
      "Unlimited professionally edited photos",
      "High quality colour graded pictures",
      "Shared via Google Drive or Pendrive",
      "High resolution images"
    ]
  },
  classic: {
    name: "Classic",
    description: "Our most popular choice",
    deliveryTime: "6-69 days",
    features: [
      "Everything in Starter package",
      "Precise masking editing",
      "Priority editing",
      "Unlimited professionally edited photos"
    ],
    highlight: true
  },
  elite: {
    name: "Elite",
    description: "The complete experience",
    deliveryTime: "6-69 days",
    features: [
      "Everything in Classic package",
      "Additional 20-page Photo Book",
      "Matte or gloss finish options",
      "Soft or hardcover choice",
      "Priority delivery"
    ]
  }
};

// Additional services - Photography
export const ADDITIONAL_SERVICES_PHOTO = [
  {
    id: "on_site_prints",
    name: "On-site Printed Pics",
    description: "Random edited printed pics during the event with or without frames (max 30 pics)",
    price: 50
  },
  {
    id: "outdoor_day",
    name: "Additional Day - Outdoor Photography",
    description: "Extra day of outdoor photography coverage",
    price: 65
  }
];

// Additional services - Videography
export const ADDITIONAL_SERVICES_VIDEO = [
  {
    id: "reel_video",
    name: "Reel/Short Video",
    description: "5-10 mins video including home, venue, parks. 4K video delivery within 1-30 days",
    price: 180
  },
  {
    id: "drone_shots",
    name: "Drone Shots",
    description: "Aerial drone footage to enhance your coverage",
    price: 50
  },
  {
    id: "full_video_hd",
    name: "Full Length Video (HD)",
    description: "45 mins full length video, colour graded and edited as per your choice. HD delivery via Google Drive or pendrive within 15-69 days",
    price: 250
  },
  {
    id: "full_video_4k",
    name: "Full Length Video (4K)",
    description: "45 mins full length video, colour graded and edited as per your choice. 4K delivery via Google Drive or pendrive within 15-69 days",
    price: 300
  }
];

// Combined additional services
export const ADDITIONAL_SERVICES = [...ADDITIONAL_SERVICES_PHOTO, ...ADDITIONAL_SERVICES_VIDEO];

// Referral options
export const REFERRAL_OPTIONS = [
  "Google Search",
  "Instagram",
  "Facebook",
  "Friend/Family Recommendation",
  "Previous Customer",
  "Wedding Fair/Event",
  "Other"
];

// Coverage options
export const COVERAGE_OPTIONS = [
  "Home",
  "Park",
  "Venue",
  "Church",
  "Office",
  "Studio",
  "Outdoor Location"
];

// Minimum order for discount
export const MINIMUM_DISCOUNT_ORDER = 200;

// Calculate total price
export const calculateTotal = (eventType, packageTier, additionalServices = [], discountPercent = 0) => {
  const eventPricing = EVENT_PRICING[eventType];
  if (!eventPricing) return { basePrice: 0, servicesTotal: 0, subtotal: 0, discount: 0, total: 0 };
  
  const basePrice = eventPricing[packageTier] || 0;
  
  const servicesTotal = additionalServices.reduce((sum, serviceId) => {
    const service = ADDITIONAL_SERVICES.find(s => s.id === serviceId);
    return sum + (service?.price || 0);
  }, 0);
  
  const subtotal = basePrice + servicesTotal;
  
  // Discount only applies if order is over £200
  let discount = 0;
  if (subtotal >= MINIMUM_DISCOUNT_ORDER && discountPercent > 0) {
    discount = (subtotal * discountPercent) / 100;
  }
  
  return {
    basePrice,
    servicesTotal,
    subtotal,
    discount,
    total: subtotal - discount,
    discountApplied: subtotal >= MINIMUM_DISCOUNT_ORDER
  };
};

// Get available packages for an event type
export const getAvailablePackages = (eventType) => {
  const event = EVENT_PRICING[eventType];
  if (!event) return [];
  
  const available = [];
  if (event.saver_london) available.push('saver_london');
  if (event.saver_outside_london) available.push('saver_outside_london');
  if (event.starter) available.push('starter');
  if (event.classic) available.push('classic');
  if (event.elite) available.push('elite');
  
  return available;
};

// Spin wheel prizes
export const SPIN_PRIZES = [
  { value: 0, label: "0%", color: "#1a1a1a" },
  { value: 5, label: "5%", color: "#D4AF37" },
  { value: 10, label: "10%", color: "#1a1a1a" },
  { value: 15, label: "15%", color: "#D4AF37" },
  { value: 20, label: "20%", color: "#1a1a1a" },
  { value: 25, label: "25%", color: "#D4AF37" },
  { value: 30, label: "30%", color: "#1a1a1a" }
];
